import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import { Typography2 } from '@coursera/cds-core';

import HelpTipCardWithDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/HelpTipCardWithDialog';
import { isDegree } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';

import _t from 'i18n!nls/degree-home';

const TipReadyForYourNextDegreeCourse: React.VFC<{ learnerAdmissionStatus: LearnerAdmissionStatus }> = ({
  learnerAdmissionStatus,
}) => {
  if (!isDegree(learnerAdmissionStatus)) {
    return null;
  }

  return (
    <HelpTipCardWithDialog
      title={_t('Ready for your next for-credit degree course?')}
      tip={_t('Go through the enrollment flow at the university’s website and come back to continue learning.')}
      dialogTitle={_t('Ready for your next for-credit degree course?')}
      dialogMessage={
        <Typography2 component="p">
          {_t(
            'Enroll in a course for university credit by registering through the university portal. Your course will automatically be added to your Coursera account when the session starts. Simply complete the registration form, pay tuition, and start learning.'
          )}
        </Typography2>
      }
    />
  );
};

export default TipReadyForYourNextDegreeCourse;
